import { BundlePaymentPlan } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { web3Api } from 'store/queries';
import { featureConfig } from 'modules/common/featureConfig';

import { fetchBundlePaymentPlansMock } from './mocks/fetchBundlePaymentPlansMock';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchBundlePaymentPlans },
  useFetchBundlePaymentPlansQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchBundlePaymentPlans: build.query<BundlePaymentPlan[], void>({
      queryFn: createNotifyingQueryFn(async () => {
        if (featureConfig.offlineTesting) {
          return { data: await fetchBundlePaymentPlansMock() };
        }

        const api = MultiService.getService().getAccountingGateway();

        const data = await api.getBundlePaymentPlans();

        return { data };
      }),
    }),
  }),
  overrideExisting: true,
});
